import classes from './products.module.css';

/*
 * Accent colours are IDENTITY only (one per product).
 * Gold stays the interactive colour on every CTA, per the brand rule.
 */
const PRODUCTS = [
    {
        key: 'prepbox',
        name: 'PrepBox',
        who: 'for students',
        accent: 'blue',
        line: 'Where the work happens.',
        body: "The student solves on an iPad exactly as they would on paper — with a tutor who can see the page live, a video lesson attached to every question, and the complete solution kept as it was actually written, stroke by stroke.",
        links: [{ label: 'Visit PrepBox', href: 'https://www.prepbox.io' }],
    },
    {
        key: 'prepboxpro',
        name: 'PrepBoxPro',
        who: 'for centres & tutors',
        accent: 'gold',
        line: 'Your tutor walks in already knowing.',
        body: 'Session plans built from what each student actually did last time, marking handled, and a parent-ready report at the end of every session. No curriculum expertise demanded of the tutor — the curriculum is already in the system, so their hour goes to teaching.',
        links: [{ label: 'For centres & tutors', href: 'https://prepboxpro.com' }],
    },
    {
        key: 'mathpulse',
        name: 'MathPulse',
        who: 'for parents',
        accent: 'teal',
        line: 'The map underneath the mark.',
        body: "A mark records the outcome; it cannot locate the cause. MathPulse shows the learning beneath it — which foundations look solid, which are still developing, and what deserves attention next — built from your own child's written work.",
        links: [
            {
                label: 'App Store',
                href: 'https://apps.apple.com/ca/app/mathpulse/id6759286329',
            },
            {
                label: 'Google Play',
                href: 'https://play.google.com/store/apps/details?id=com.prepanywhereparent&hl=en_CA',
            },
        ],
    },
];

const Products = () => {
    return (
        <section id="products" className={classes.section} aria-labelledby="products-title">
            <div className={classes.inner}>
                <div className={classes.head}>
                    <p className="eyebrow">Our products</p>
                    <h2 id="products-title" className={classes.title}>
                        Three products. One loop.
                    </h2>
                    <p className={classes.lede}>
                        PrepAnywhere is the company. These are the three places the same
                        evidence shows up — for the student writing it, the teacher acting
                        on it, and the parent trying to understand it.
                    </p>
                </div>

                <div className={classes.grid}>
                    {PRODUCTS.map((p) => (
                        <article key={p.key} className={classes.card}>
                            <span
                                className={`${classes.rule} ${classes[p.accent]}`}
                                aria-hidden="true"
                            />

                            <p className={classes.who}>
                                <span
                                    className={`${classes.swatch} ${classes[p.accent]}`}
                                    aria-hidden="true"
                                />
                                {p.who}
                            </p>

                            <h3 className={classes.name}>{p.name}</h3>
                            <p className={classes.line}>{p.line}</p>
                            <p className={classes.body}>{p.body}</p>

                            <div className={classes.links}>
                                {p.links.map((l) => (
                                    <a
                                        key={l.href}
                                        className={classes.cta}
                                        href={l.href}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {l.label}
                                    </a>
                                ))}
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Products;
